import React, { useMemo } from 'react';
import styled from 'styled-components';
import { truncate } from '@/utils/types';
import { hash } from '@/utils/cache';
import { SelectorTooltip } from './selector-tooltip';

interface SelectorSectionProps {
  selector: string;
  editorId: string;
  image: string;
  limit?: number;
}

export function SelectorSection({
  selector,
  editorId,
  image,
  limit = 30,
}: SelectorSectionProps) {
  const id = useMemo(
    () => `selector-${hash(`${editorId}-${selector}`)}`,
    [editorId, selector],
  );

  const truncatedSelector = useMemo(
    () => truncate(selector, limit),
    [selector, limit],
  );

  return (
    <>
      <SelectorWrapper data-tip data-for={id}>
        {truncatedSelector}
      </SelectorWrapper>
      <SelectorTooltip id={id} selector={selector} image={image} />
    </>
  );
}

const SelectorWrapper = styled.span`
  text-decoration: none;
  color: black;
  font-weight: bold;

  :hover {
    text-decoration: underline;
  }
`;
